export const twillioActiontypes = {
  UPDATE_CALLING_STATUS: "UPDATE_CALLING_STATUS",
  UPDATE_COUNTER_STATUS: "UPDATE_COUNTER_STATUS",
  UPDATE_ERROR_STATUS: "UPDATE_ERROR_STATUS",
  START_CALL: "START_CALL",
  CLEAR_CALL_DATA: "CLEAR_CALL_DATA",
};
